var styleDataHash = '019e45a6';  
export const injectCss = (() => {
  var css = `.sortableHelper{z-index:10000!important}.pGxMU{height:100%}[dir] .pGxMU{border-radius:var(--ricos-settings-whitebox-border-radius,0);cursor:grab}[dir] .pGxMU:active{cursor:grabbing}.pGxMU:hover{opacity:.7}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "itemImage": "pGxMU"
};